export enum PartnerSettings {
  SHOW_TAX = 'show_tax',
  PARTNER_PORTAL_HIDE_PRICE_RANGE = 'partner_portal_hide_price_range',
}
